import type { ListRiskControlsArgs } from '@moment/trading-types/risk'

/**
 * `fetchBaseQuery` comma-joins array params into a single value, so the
 * repeated `type=` form the service expects is built by hand.
 */
export function riskControlsQuery(
  args: ListRiskControlsArgs | undefined,
): string {
  const types = args?.types ?? []
  if (types.length === 0) {
    return ''
  }

  const search = new URLSearchParams()
  for (const type of types) {
    search.append('type', type)
  }

  return `?${search}`
}
